/**
 * @author Code Lai（赖传峰）
 * @email codelai@staritgp.com
 * @date 2019-07-31 19:20
 */
import React from 'react'

interface WithAccountBalancePropType {
  fetchAccountBalance: NoArgVoidFunc,
  accountBalance: undefined |
    {
      frozenBalance: number, // 冻结余额
      settleBalance: number, // 未结算余额
      freeBalance: number, // 可用余额
    },
}
const context = React.createContext({} as WithAccountBalancePropType)
const { Provider, Consumer } = context

export default Component => function withAccountBalance (props) {
  return (
    <Consumer>
      {
        ({ fetchAccountBalance, accountBalance }) => (
          <Component
            fetchAccountBalance={fetchAccountBalance}
            accountBalance={accountBalance}
            {...props}
          />
        )
      }
    </Consumer>
  )
}

export { Provider as AccountBalanceProvider, context as AccountBalanceContext, WithAccountBalancePropType }
